import { render, staticRenderFns } from "./cut-setting.vue?vue&type=template&id=7488b230&scoped=true"
import script from "./cut-setting.vue?vue&type=script&setup=true&lang=js"
export * from "./cut-setting.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cut-setting.vue?vue&type=style&index=0&id=7488b230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7488b230",
  null
  
)

export default component.exports